// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Checkout_wrapper__2rL2Q","qty":"Checkout_qty__1-Rpm","bold":"Checkout_bold__1Dm0O","orderBtn":"Checkout_orderBtn__1OiNv","deliveryTime":"Checkout_deliveryTime__2QnDh"};